import { useField, useFormikContext } from 'formik';

import { CustomerCompanySelect, type CustomerCompanySelectProps } from '../CompanySelect/CustomerCompanySelect';

interface FormikCustomerCompanySelectProps extends Omit<CustomerCompanySelectProps, 'onChange' | 'value'> {
    name: string;
    onCustomerChange?: (customerId: string) => void;
}

export function FormikCustomerCompanySelect(props: FormikCustomerCompanySelectProps) {
    const [field, meta, helpers] = useField<string>(props.name);
    const { validateOnChange } = useFormikContext();

    const onChange = (customerId: string) => {
        helpers.setValue(customerId);
        props.onCustomerChange?.(customerId);
        if (!validateOnChange && meta.error) {
            helpers.setError(undefined);
        }
    };

    return (
        <CustomerCompanySelect
            {...props}
            onChange={onChange}
            value={field.value}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : props.caption}
            onBlur={() => {
                helpers.setTouched(true);
            }}
        />
    );
}
